import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef } from "react";
import TextareaAutosizeComponent from "react-textarea-autosize";
import { TEXTAREA_SIZE_CLASSES, textareaClasses } from "./constants";
export const TextareaAutosize = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, size = "medium", ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(TextareaAutosizeComponent, {
        className: tailwindMerge(textareaClasses, TEXTAREA_SIZE_CLASSES[size], className),
        ref: forwardedRef,
        ...restOfProps
    });
});
TextareaAutosize.displayName = "TextareaAutosize";
